export type AutoRenewMandateStatus =
  | 'pending'
  | 'active'
  | 'past_due'
  | 'cancelled'
  | 'completed'
  | 'halted'
  | string;

export interface AutoRenewMandate {
  razorpaySubscriptionId: string;
  status: AutoRenewMandateStatus;
  autoRenews?: boolean;
  expireTime?: string | Date;
  planPurchaseId?: string;
}

const CANCELLABLE_STATUSES = new Set(['pending', 'active', 'past_due']);

/** Mandates the org can cancel — pending / active / past_due and autoRenews !== false. */
export function isCancellableAutoRenewMandate(mandate: AutoRenewMandate): boolean {
  if (mandate.autoRenews === false) {
    return false;
  }
  return CANCELLABLE_STATUSES.has(String(mandate.status || '').toLowerCase());
}
